import { render, staticRenderFns } from "./EditInternetRegistration.vue?vue&type=template&id=9e84b33e"
import script from "./EditInternetRegistration.vue?vue&type=script&lang=js"
export * from "./EditInternetRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports